import { render, staticRenderFns } from "./ComplainOrderManagement.vue?vue&type=template&id=14adcf12&scoped=true"
import script from "./ComplainOrderManagement.vue?vue&type=script&lang=js"
export * from "./ComplainOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./ComplainOrderManagement.vue?vue&type=style&index=0&id=14adcf12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14adcf12",
  null
  
)

export default component.exports